/* eslint-disable react/style-prop-object */

import { useContext, useState } from "react";
import { filtrationcontext } from "../../context/Filtercontext";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import trans from "../../utils";

export default function ProjectsetupHeader() {
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};

	return (
		<>
			<div className="bg-white p-16 ">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
			</div>
		</>
	);
}
